module.exports = __webpack_public_path__ + "static/media/offcontact.d7b1bcb8.svg";